import { useSetAtom } from "jotai";
import { useConversationHistory } from "utilities/atoms/conversations/conversation-history/use-conversation-history.hook";
import {
    BookviewConversationAtom,
    ModalConversationAtom,
    NotebookConversationAtom,
} from "utilities/atoms/conversations/current-conversation/conversation-atoms";

interface UseConversationGlobalState {
    /**
     * Clears all conversation state, including current conversations and conversation history.
     */
    clear(): void;
}

export function useConversationGlobalState(): UseConversationGlobalState {
    const { clearConversationHistory } = useConversationHistory();
    const dispatchModelConversation = useSetAtom(ModalConversationAtom);
    const dispatchBookviewConversation = useSetAtom(BookviewConversationAtom);
    const dispatchNotebookConversation = useSetAtom(NotebookConversationAtom);

    return {
        clear() {
            clearConversationHistory();
            dispatchModelConversation({ type: "CLEAR_CONVERSATION" });
            dispatchBookviewConversation({ type: "CLEAR_CONVERSATION" });
            dispatchNotebookConversation({ type: "CLEAR_CONVERSATION" });
        },
    };
}
